<div class="container my-4">
  <div class="card custom-card">
    <div class="card-header custom-header">
      <h2 class="mb-0">{{ 'chemical.regulation.title' | translate }}</h2>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <h5 class="card-title">{{ 'chemical.regulation.input_info' | translate }}</h5>
        <div class="info-box">
          {{ 'chemical.regulation.info_text' | translate }}<br>
          {{ 'chemical.regulation.info_text_note' | translate }}<br>
        </div>
      </div>

      <!-- 載入指示器 -->
      <div class="text-center my-3" *ngIf="loading && !searchPerformed">
        <div class="spinner-border custom-spinner" role="status">
          <span class="visually-hidden">{{ 'chemical.regulation.loading' | translate }}</span>
        </div>
        <p class="mt-2">{{ 'chemical.regulation.loading_data' | translate }}</p>
      </div>

      <div *ngIf="!loading || searchPerformed">
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead class="custom-table-header">
              <tr>
                <th>{{ 'chemical.regulation.chinese_name' | translate }}</th>
                <th>{{ 'chemical.regulation.english_name' | translate }}</th>
                <th>{{ 'chemical.regulation.cas_no' | translate }}</th>
                <th>{{ 'chemical.regulation.concentration' | translate }}</th>
                <th class="text-center" style="width: 100px">{{ 'chemical.regulation.operation' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let component of components; let i = index">
                <td>
                  <input type="text" class="form-control" [(ngModel)]="component.chineseName" [placeholder]="'chemical.regulation.placeholder.chinese_name' | translate">
                </td>
                <td>
                  <input type="text" class="form-control" [(ngModel)]="component.englishName" [placeholder]="'chemical.regulation.placeholder.english_name' | translate">
                </td>
                <td>
                  <input type="text" class="form-control" [(ngModel)]="component.casNo" [placeholder]="'chemical.regulation.placeholder.cas_no' | translate">
                </td>
                <td>
                  <input type="text" class="form-control" [(ngModel)]="component.percentage" [placeholder]="'chemical.regulation.placeholder.concentration' | translate">
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-danger-custom btn-sm" (click)="removeComponent(i)"
                    [disabled]="components.length === 1">
                    <i class="bi bi-trash"></i> {{ 'chemical.regulation.delete' | translate }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between mb-4">
          <button type="button" class="btn btn-success-custom" (click)="addComponent()">
            <i class="bi bi-plus-circle"></i> {{ 'chemical.regulation.add_component' | translate }}
          </button>
          <div>
            <button type="button" class="btn btn-primary-custom me-2" (click)="checkRegulations()">
              <i class="bi bi-search"></i> {{ 'chemical.regulation.check_status' | translate }}
            </button>
            <button type="button" class="btn btn-secondary-custom" (click)="resetSearch()">
              <i class="bi bi-arrow-repeat"></i> {{ 'chemical.regulation.reset' | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- 檢查時的載入指示器 -->
      <div class="text-center my-3" *ngIf="loading && searchPerformed">
        <div class="spinner-border custom-spinner" role="status">
          <span class="visually-hidden">{{ 'chemical.regulation.checking' | translate }}</span>
        </div>
        <p class="mt-2">{{ 'chemical.regulation.checking_please_wait' | translate }}</p>
      </div>

      <!-- 結果展示區域 -->
      <div *ngIf="searchPerformed && !loading">
        <h5 class="card-title mt-4">{{ 'chemical.regulation.check_result' | translate }}
<!-- 添加展開/收合按鈕 -->
<button *ngIf="matchedRegulations.length > 0" type="button" class="btn btn-sm btn-outline-secondary float-end"
  (click)="toggleAllDetails()">
<i class="bi" [ngClass]="allDetailsOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
{{ allDetailsOpen ? ('chemical.regulation.collapse_all' | translate) : ('chemical.regulation.expand_all' | translate) }}
</button>


        </h5>
        <div class="alert custom-warning-alert" *ngIf="matchedRegulations.length === 0">
          {{ 'chemical.regulation.no_match' | translate }}
        </div>

        <div *ngIf="matchedRegulations.length > 0">
          <div class="mb-4" *ngFor="let category of groupedRegulations | keyvalue">
            <div class="regulation-category d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <div class="form-check me-2">
                  <input class="form-check-input" type="checkbox" [id]="'category-' + category.key"
                    [(ngModel)]="categoryEnabledMap[category.key]" (change)="updateSummary()" checked>
                  <label class="form-check-label text-white" [for]="'category-' + category.key">
                    {{ category.key }}
                  </label>
                </div>
              </div>
            </div>

            <div class="mb-3" *ngFor="let subCategory of category.value | keyvalue">
              <!-- 預設展開 -->
              <details class="regulation-subcategory" open>
                <summary>
                  {{ subCategory.key }} <span class="badge bg-secondary ms-2">{{ subCategory.value.length }}</span>
                </summary>
                <div class="table-responsive mt-2">
                  <table class="table table-striped table-bordered">
                    <thead class="custom-table-results-header">
                      <tr>
                        <th>{{ 'chemical.regulation.cas_no' | translate }}</th>
                        <th>{{ 'chemical.regulation.chinese_name' | translate }}</th>
                        <th>{{ 'chemical.regulation.english_name' | translate }}</th>
                        <th>{{ 'chemical.regulation.control_concentration' | translate }}</th>
                        <!-- <th>對應成分</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of subCategory.value">
                        <td>
                          <span [class.highlight]="item.matchedField && item.matchedField.includes('casNo')">
                            {{ item.casNo || '-' }}
                          </span>
                        </td>
                        <td>
                          <span [innerHTML]="item.matchedField && item.matchedField.includes('chemicalName') ?
                            highlightText(item.chemicalName, item.matchedText) : (item.chemicalName || '-')">
                          </span>
                        </td>
                        <td>
                          <span [innerHTML]="item.matchedField && item.matchedField.includes('englishName') ?
                            highlightText(item.englishName, item.matchedText) : (item.englishName || '-')">
                          </span>
                        </td>
                        <td>{{ item.percentage || '-' }}</td>
                        <!-- <td>
                          <ng-container *ngIf="item.matchedComponentIndices && item.matchedComponentIndices.length > 0">
                            <ng-container *ngFor="let index of getUniqueComponentIndices(item.matchedComponentIndices); let i = index">
                              <span class="badge me-1">{{ index + 1 }}</span>
                            </ng-container>
                          </ng-container>
                        </td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </details>
            </div>
          </div>

          <!-- 摘要區域保持不變 -->
          <div class="alert custom-info-alert mt-4">
            <h3 class="mb-2"><i class="bi bi-info-circle-fill me-2"></i>{{ 'chemical.regulation.regulation_summary' | translate }}</h3>
            <div class="summary-text" [innerHTML]="summaryText"></div>
          </div>

          <!-- <div class="alert custom-danger-alert mt-3">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            <strong>警告：</strong> 已發現部分成分屬於管制化學品，請注意相關法規要求。
          </div> -->
        </div>
      </div>
    </div>
  </div>
<!-- 儲存按鈕：當 components 有值時顯示 -->
<div *ngIf="inputcomponents && inputcomponents.length > 0" class="text-end">
  <button type="button" class="btn btn-primary-custom w-100 mt-3" (click)="onSave()">
    <i class="bi bi-save"></i> {{ 'chemical.regulation.save' | translate }}
  </button>
</div>
</div>
